export enum UserRoles {
    Admin = "Admin",
    QuizCreator = "QuizCreator",
    QuizParticipator = "QuizParticipator"
}
  